module.exports = __webpack_public_path__ + "static/media/8-4.a0054cd0.mp3";